import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";
import { useEffect } from "react";

const utils = createTrackingUtils({
  name: "flights_web_hide_progress_container",
  stages: {
    main: 1,
    direct: 2,
    meta: 3
  },
  defaultStage: 1,
  goals: {},
  goalsWithValue: ["step_submit_count"]
});

export const useTrackBlockoutProgressContainer = () => {
  const { isMeta } = useProfiler();

  useEffect(() => {
    isMeta() ? utils.stages.meta() : utils.stages.direct();
  }, [isMeta]);
};

export default utils;
